<template>
  <div>
    <div class="text-center mt-2">
      <img width="62px" src="@/assets/logo.png" />
    </div>
    <div v-if="loading" class="text-center">
      <v-progress-circular
        indeterminate
        class="mt-6"
        color="primary"
        size="65"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-tabs-items touchless v-model="tab">
        <v-tab-item active-class="onactivetabmenu" :key="'collect'">
          <Collect
            style="padding-bottom: 85px"
            v-if="tab === 0"
            @isBlockedUser="handleRedirectToProfile"
            @success="handleSaveSuccess"
          ></Collect>
        </v-tab-item>
        <v-tab-item :key="'reward'">
          <Reward
            v-if="tab === 1"
            @isBlockedUser="handleRedirectToProfile"
            @toRewardDetail="tab = 'rewarddetail'"
            style="padding-bottom: 85px"
          ></Reward>
        </v-tab-item>
        <v-tab-item :key="'profile'">
          <Profile
            v-if="tab === 2"
            @toReward="tab = 'reward'"
            style="padding-bottom: 85px"
          ></Profile>
        </v-tab-item>
      </v-tabs-items>

      <v-tabs
        @change="onChangeTab"
        active-class="onactivetabmenu"
        :slider-size="5"
        :slider-color="'red'"
        icons-and-text
        style="
          max-width: 500px;
          position: fixed;
          bottom: 0;
          box-shadow: 0px 0 10px rgba(0, 0, 0, 0.2);
          z-index: 2;
        "
        v-model="tab"
        color="#B3131B"
        grow
        background-color="primary"
      >
        <v-tab :key="'collect'">
          <div>
            <v-img
              v-if="tab === 0"
              width="38px"
              src="./assets/collect-active.png"
            ></v-img>
            <v-img v-else width="38px" src="./assets/collect.png"></v-img>
          </div>
          <div
            style="font-size: 12px"
            class="white--text text-center mb-1"
            :class="{ 'red--text': tab === 0 }"
          >
            สะสมแต้ม
          </div>
        </v-tab>
        <v-tab :key="'reward'">
          <div>
            <v-img
              v-if="tab === 1"
              width="32px"
              src="./assets/reward-active.png"
            ></v-img>
            <v-img v-else width="32px" src="./assets/reward.png"></v-img>
          </div>
          <div
            style="font-size: 12px"
            class="white--text text-center mb-2"
            :class="{ 'red--text': tab === 1 }"
          >
            รางวัล
          </div>
        </v-tab>
        <v-tab :key="'profile'">
          <div>
            <v-img
              v-if="tab === 2"
              width="35px"
              src="./assets/profile-active.png"
            ></v-img>
            <v-img v-else width="35px" src="./assets/profile.png"></v-img>
          </div>
          <div
            style="font-size: 12px"
            class="white--text text-center mb-2"
            :class="{ 'red--text': tab === 2 }"
          >
            สมาชิก
          </div>
        </v-tab>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import Collect from "./Collect.vue";
import Reward from "./Reward.vue";
import Profile from "./Profile.vue";
import axios from "axios";
export default {
  data() {
    return {
      tab: "collect",
      loading: true,
    };
  },
  components: {
    Collect,
    Reward,
    Profile,
  },
  async mounted() {
    if (this.query.tab) {
      if (this.query.tab == "profile") {
        this.tab = 2;
      }
      if (this.query.tab == "reward") {
        this.tab = 1;
      }
      if (this.query.tab == "collect") {
        this.tab = 0;
      }
    }

    if (
      this.$store.state.member &&
      Object.keys(this.$store.state.member).length === 0
    ) {
      await this.getMember();
    }

    if (
      this.$store.state.member &&
      Object.keys(this.$store.state.member).length > 0
    ) {
      await this.getAddress();
    }
    this.loading = false;
  },
  methods: {
    onChangeTab(tab) {
      if (tab === 2) {
        this.query.tab = "profile";
      }
      if (tab === 1) {
        this.query.tab = "reward";
      }
      if (tab === 0) {
        this.query.tab = "collect";
      }
    },
    getMember() {
      return new Promise((resolve) => {
        var data = { userid: this.userid, pageid: this.query.pageid };
        axios
          .get(this.serverUrl + "toacrm/member", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.member = response.data.data[0];
            } else {
              this.$store.state.redirectview = "Register";
              this.query.view = this.$store.state.redirectview;
              // await this.$swal.fire({ text: response.data.reason });
              // this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    getAddress() {
      return new Promise((resolve) => {
        var data = {
          memberId: this.$store.state.member.memberId,
        };
        axios
          .get(this.serverUrl + "toacrm/member-address", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              this.$store.state.address = response.data.data || [];
            } else {
              await this.$swal.fire({ text: response.data.reason });
              this.$liff.closeWindow();
            }
            resolve();
          });
      });
    },
    handleRedirectToProfile() {
      this.tab = 2;
    },
    async handleSaveSuccess() {
      await this.$store.dispatch("sendMessage", "อัปโหลดใบเสร็จสำเร็จ");
    },
  },
};
</script>

<style lang="scss">
.onactivetabmenu {
  background-color: white !important;
  color: #2a72c3 !important;
}
</style>
